import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import { getSurveysPermissionVerbs } from 'modules/surveys/lib/getSurveysPermissionVerbs'

function SurveysActions() {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const verbs = getSurveysPermissionVerbs()
  const formVerbType = verbs.forms?.permission
  const canCreateForms = formVerbType ? users.current.policy.can(formVerbType) : false

  const newOnClick = () => {
    track(trackingEvents.surveys.createSurveyStart)
    navigate(navigation.engagement.surveys.creation.fullPath())
  }

  if (!canCreateForms) {
    return null
  }

  return (
    <Button iconName="add" onClick={newOnClick}>
      {i18n.t('surveys.index.actions.new')}
    </Button>
  )
}

export default SurveysActions
